import { ReactNode } from "react"
import cn from "classnames"

import style from "modules/BookingCommon/components/HeadlineSessionDate/style.module.scss"

interface Props {
    children: ReactNode
    className: string
}

export function HeadlineSessionDate({ children, className }: Props) {
    return <div className={cn(style.headlineSessionDate, className)}>{children}</div>
}
